import {
  GET_ALL_DEPARTMENTAL_MONEY_COUNT,
  GET_ALL_DEPARTMENTAL_MONEY_COUNT_DATA,
  GET_ALL_DEPARTMENTAL_MONEY_PENDING,
  GET_ALL_DEPARTMENTAL_PROCESS_APPROVED,
  /******************* USER WALLET *********************/
  GET_ALL_USER_WALLET_MONEY_COUNT,
  GET_ALL_USER_MONEY_PENDING,
  GET_ALL_USER_PROCESS_APPROVED,
  GET_ALL_USER_REFERRALS,
  GET_ALL_TRANSFER_MONEY,
  GET_ALL_TRANSFER_MONEY_PROCESS,
} from "../../types";

const initialState = {
  get_all_departmental_money: {},
  get_all_departmental_money_data: [],
  get_all_departmental_pendings: [],
  get_all_departmental_process_approved: [],
  /******************* USER WALLET *********************/
  get_all_user_wallet_money_count: [],
  get_all_users_money_pending: [],
  get_all_user_process_approved: [],
  get_all_user_referrals: [],
  get_all_transfer_money: [],
  get_all_transfer_money_process_approved: [],
};

export default function (state = initialState, action) {
  const { type, payload } = action;
  switch (type) {
    case GET_ALL_DEPARTMENTAL_MONEY_COUNT:
      return {
        ...state,
        get_all_departmental_money: payload,
      };
    case GET_ALL_DEPARTMENTAL_MONEY_COUNT_DATA:
      return {
        ...state,
        get_all_departmental_money_data: payload,
      };
    case GET_ALL_DEPARTMENTAL_MONEY_PENDING:
      return {
        ...state,
        get_all_departmental_pendings: payload,
      };
    case GET_ALL_DEPARTMENTAL_PROCESS_APPROVED:
      return {
        ...state,
        get_all_departmental_process_approved: payload,
      };
    /**********************
     * @DESC USER WALLET
     *********************/
    case GET_ALL_USER_WALLET_MONEY_COUNT:
      return {
        ...state,
        get_all_user_wallet_money_count: payload,
      };
    case GET_ALL_USER_MONEY_PENDING:
      return {
        ...state,
        get_all_users_money_pending: payload,
      };
    case GET_ALL_USER_PROCESS_APPROVED:
      return {
        ...state,
        get_all_user_process_approved: payload,
      };
    case GET_ALL_USER_REFERRALS:
      return {
        ...state,
        get_all_user_referrals: payload,
      };
    case GET_ALL_TRANSFER_MONEY:
      return {
        ...state,
        get_all_transfer_money: payload,
      };
    case GET_ALL_TRANSFER_MONEY_PROCESS:
      return {
        ...state,
        get_all_transfer_money_process_approved: payload,
      };
    default:
      return state;
  }
}
